import React from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const CalendarView = (props) => {
  const { onChange, value, tileClassName, onActiveStartDateChange } = props;
  return (
    <div className="calendar-view">
      <Calendar
        onChange={onChange}
        onActiveStartDateChange={onActiveStartDateChange}
        value={value}
        minDate={new Date()}
        tileClassName={tileClassName}
      />
    </div>
  );
};

export default CalendarView;
